import { onFetchBasket } from '@state/basket';
import { onNavigate, onRedirect } from '@state/slices/app/routing';
import { all } from 'redux-saga/effects';
import combinedBasketSagas from '@state/basket/combinedBasketSagas';
import {
  handleOnLoadMore,
  onRequestFromPricePackagesSearch,
  onSetFromPriceFilters
} from '@state/search-results/from-price-packages/fromPricePackagesOperations';
import { combinedDataLayerMiddlewareSagas } from '../../middleware/combinedDataLayerMiddlewareSagas';
import { combinedSearchResultsSagas } from '@state/search-results/combineSearchResultsSagas';

export default function* rootSaga() {
  yield all([
    onRequestFromPricePackagesSearch(),
    onSetFromPriceFilters(),
    handleOnLoadMore(),
    onFetchBasket(),
    onNavigate(),
    onRedirect(),
    combinedBasketSagas(),
    combinedDataLayerMiddlewareSagas(),
    combinedSearchResultsSagas()
  ]);
}
